export default [
  /auto.incidents.([^.]*).type/,
  /auto.incidents.([^.]*).date/,
  /auto.incidents.([^.]*).operatingDriver/,
  /auto.incidents.([^.]*).involvedVehicle/,
  /auto.incidents.([^.]*).description/,
  /auto.incidents.([^.]*).description/,
]
